function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  transform: "scale(-.93955 -1.057) rotate(-45 -7.483 17.257)",
  stroke: "#FAFAFA",
  d: "M0-.5h18.062"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  transform: "scale(.93955 -1.057) rotate(-45 .526 -2.077)",
  stroke: "#FAFAFA",
  d: "M0-.5h18.062"
});

function SvgSearchInputCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgSearchInputCloseinline;